export type QuotationPopupState = {
    form: {
        validatingDocumentNumber: boolean;
        isDocumentValidByEquifax: boolean;
        submitting: boolean;
    };
    customerAlreadyHasPolicyPopup: {
        opened: boolean;
    };
    cannotOfferThisProductPopup: {
        opened: boolean;
    };
};

export const quotationStateDefaultState: QuotationPopupState = {
    form: {
        validatingDocumentNumber: false,
        isDocumentValidByEquifax: false,
        submitting: false,
    },
    customerAlreadyHasPolicyPopup: {
        opened: false,
    },
    cannotOfferThisProductPopup: {
        opened: false,
    },
};
